import styled from "styled-components";
import React from "react";
import colors from "../../utils/colors";

const authorImageDimension = 94;

export const AuthorImageWrapper = styled.div`
  min-width: ${authorImageDimension}px;
  width: ${authorImageDimension}px;
  height: ${authorImageDimension}px;
  margin: 10px 15px 0 0;
  overflow: hidden;
  display: block;
  border-radius: ${authorImageDimension / 2}px;
  background-color: ${colors.placeholderGrey};
  float: left;
`;

export const AuthorImageStyle = styled.img`
  width: ${authorImageDimension}px;
  height: ${authorImageDimension}px;
`;

export const AuthorImageGrid = styled.div`
  display: grid;
`;

export default function AuthorImage({ author, showImage }) {
  if (!showImage || !author.image.paths?.derivates || author.image.paths.derivates.length === 0) {
    return <></>;
  }

  return(
    <AuthorImageWrapper>
      <AuthorImageStyle
        src={author.image.paths?.derivates.shn_team_image}
        alt={author.image.alt}
        title={author.name} />
    </AuthorImageWrapper>
  );
}
